/* eslint-disable */
/**
 * OSCockpit.jsx — Overblik-forside til OS-admin
 *
 * Fase E (2026-06-11): Erstatter akkordeon-strukturen (CockpitZone1-4)
 * med OverblikPanel — rigt, Sager-stil dashboard.
 *
 * Akkordeon-komponenterne (CockpitZone1-4, AkkordeonZone) bevares i
 * kodebasen (under ./paneler/ og ./komponenter/) men monteres IKKE
 * fra denne fil. Flag-OFF = gammelt OSDashboard.jsx uændret.
 *
 * onNavigerTilFane-prop bevares for bagudkompatibilitet med
 * OSDashboardNy.jsx's renderDashboard().
 */

import React from 'react';
import OverblikPanel from './paneler/OverblikPanel';

export default function OSCockpit({ onNavigerTilFane }) {
  // onNavigerTilFane sendes ned hvis det en dag er nødvendigt at
  // navigere videre fra OverblikPanel — bruges ikke i denne fase.
  return <OverblikPanel />;
}
